import React, {Component} from "react";
import {connect} from "react-redux";
import {popupHide} from "../../../libs/redux/actions/popup";

/**
 * 팝업 닫기
 */
class PopupClose extends Component {
    componentDidUpdate(prevProps) {
        if(this.props && this.props.hasOwnProperty("close") && this.props.close) {
            this.popupClose();
        }
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    popupClose() {
        this.dispatch(popupHide());
    }

    render() {
        return (
            <div className="close-wrap"><img src="/images/icon-close.png" alt={'팝업닫기'} onClick={() => this.popupClose()} /></div>
        );
    }
}

export default connect()(PopupClose);



// WEBPACK FOOTER //
// ./src/pages/components/buttons/popup-close.jsx